import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../services/authContext';
import { apiService } from '../services/apiService';
import { portalService } from '../services/portalService';

const statusStyle = {
  present: { background: '#d4edda', color: '#155724' },
  absent: { background: '#f8d7da', color: '#721c24' },
  late: { background: '#fff3cd', color: '#856404' },
};

const MyAttendance = () => {
  const { user } = useAuth();
  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadAttendance = async () => {
      try {
        setLoading(true);
        setError('');
        const student = await portalService.getCurrentStudent(user.id);
        const [attendanceData, summaryData] = await Promise.all([
          apiService.get(`attendance/student/${student._id}`),
          apiService.get(`attendance/summary/${student._id}`),
        ]);
        setRecords(attendanceData || []);
        setSummary(summaryData || {});
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load your attendance.');
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      loadAttendance();
    }
  }, [user]);

  if (loading) return <LoadingSpinner message="Loading your attendance..." />;

  const present = summary?.present ?? 0;
  const absent = summary?.absent ?? 0;
  const late = summary?.late ?? 0;
  const percentage = summary?.percentage ?? 0;

  return (
    <div className="page-container">
      <div className="page-header"><h1>My Attendance</h1></div>

      {error && <div className="error-message">{error}</div>}

      <div className="stats-grid" style={{ marginBottom: '2rem' }}>
        {[
          { label: 'Present', value: present, color: '#388E3C' },
          { label: 'Absent', value: absent, color: '#D32F2F' },
          { label: 'Late', value: late, color: '#F57C00' },
          { label: 'Rate', value: `${percentage}%`, color: percentage >= 75 ? '#388E3C' : '#D32F2F' },
        ].map(item => (
          <div key={item.label} className="stat-card">
            <h3>{item.label}</h3>
            <div className="stat-value" style={{ color: item.color }}>{item.value}</div>
          </div>
        ))}
      </div>

      <div className="table-responsive">
        <table className="data-table">
          <thead>
            <tr><th>Date</th><th>Status</th><th>Remark</th></tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan={3} className="no-data-message" style={{ textAlign: 'center', padding: '2rem' }}>
                  No attendance records yet. Your teachers will update this as the term progresses.
                </td>
              </tr>
            ) : records.map(record => (
              <tr key={record._id || `${record.date}-${record.classId}`}>
                <td>{new Date(record.date).toLocaleDateString()}</td>
                <td>
                  <span style={{ ...statusStyle[record.status], padding: '0.2rem 0.6rem', borderRadius: 12, fontSize: '0.82rem', fontWeight: 600 }}>
                    {record.status}
                  </span>
                </td>
                <td>{record.remark || 'No remark'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyAttendance;
